(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function() {
  /* --- Product modal fix --- */
  class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.isProductPage = true;
    }

    hide() {
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(
        `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
      );

      // Αν δεν βρει media, σταμάτα εδώ για να ΜΗΝ σκάει error
      if (!activeMedia) return;

      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName === 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent();
      }
    }
  }

  // Ορισμός custom element (μόνο αν δεν έχει οριστεί ήδη)
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  /* --- BUY NOW => add to cart + redirect to checkout --- */
  function initBuyNow(root) {
    // Αν περαστεί root από section: το χρησιμοποιούμε, αλλιώς ψάχνουμε global
    const productRoot = root || document.querySelector('[id^="MainProduct-"]');
    if (!productRoot) return;

    const form      = productRoot.querySelector('product-form form');
    const buyNowBtn = productRoot.querySelector('.product-form__buy-now');

    if (!form || !buyNowBtn) return;

    // Προστασία από διπλές bindings: καθαρό clone
    const clonedBtn = buyNowBtn.cloneNode(true);
    buyNowBtn.parentNode.replaceChild(clonedBtn, buyNowBtn);

    clonedBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const variantInput = form.querySelector('input[name="id"]');
      const qtyInput     = form.querySelector('input[name="quantity"]');

      const variantId = variantInput ? variantInput.value : null;
      const quantity  = qtyInput && qtyInput.value
        ? (parseInt(qtyInput.value, 10) || 1)
        : 1;

      if (!variantId) {
        // fallback: αν για κάποιο λόγο δεν βρίσκουμε variant, κάνε normal submit
        form.submit();
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
        .then(function(res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function() {
          window.location.href = '/checkout';
        })
        .catch(function(err) {
          console.error('BUY NOW error:', err);
          form.submit();
        });
    });
  }

  // Αρχικό init όταν φορτώνει η σελίδα
  document.addEventListener('DOMContentLoaded', function() {
    initBuyNow();
  });

  // Ξανα-init όταν γίνεται section load από το theme editor
  document.addEventListener('shopify:section:load', function(event) {
    const sectionEl = event.target?.querySelector?.('[id^="MainProduct-"]');
    if (sectionEl) {
      initBuyNow(sectionEl);
    } else {
      initBuyNow();
    }
  });
})();

(function () {
  const SLIDE_DURATION = 300;

  const slideUp = (el) => {
    el.style.height = `${el.scrollHeight}px`;
    el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.transition = `height ${SLIDE_DURATION}ms ease`;
    el.style.height = '0';
    el.addEventListener(
      'transitionend',
      () => {
        el.style.display = 'none';
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('transition');
      },
      { once: true }
    );
  };

  const slideDown = (el) => {
    el.style.display = 'block';
    el.style.height = '0';
    el.style.overflow = 'hidden';
    el.offsetHeight;
    el.style.transition = `height ${SLIDE_DURATION}ms ease`;
    el.style.height = `${el.scrollHeight}px`;
    el.addEventListener(
      'transitionend',
      () => {
        el.style.removeProperty('height');
        el.style.removeProperty('overflow');
        el.style.removeProperty('transition');
      },
      { once: true }
    );
  };

  const initInlineDisclosures = () => {
    document.querySelectorAll('.product__info-container').forEach((containerEl) => {
      if (containerEl.dataset.inlineDisclosureInit) return;
      containerEl.dataset.inlineDisclosureInit = 'true';

      containerEl.querySelectorAll('.product-inline-disclosure__toggle').forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.product-inline-disclosure');
          const content = item.querySelector('.product-inline-disclosure__content');
          const isOpen = item.classList.contains('is-open');

          containerEl.querySelectorAll('.product-inline-disclosure.is-open').forEach((openItem) => {
            if (openItem !== item) {
              openItem.classList.remove('is-open');
              openItem.querySelector('.product-inline-disclosure__toggle').setAttribute('aria-expanded', 'false');
              const openContent = openItem.querySelector('.product-inline-disclosure__content');
              if (openContent) slideUp(openContent);
            }
          });

          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
          if (content) {
            if (isOpen) {
              slideUp(content);
            } else {
              slideDown(content);
            }
          }
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initInlineDisclosures);
  document.addEventListener('shopify:section:load', initInlineDisclosures);
})();

  } catch(e) { console.error(e); }
})();
})();
